import { render, staticRenderFns } from "./SubsidiaryLedger.vue?vue&type=template&id=3164826c"
import script from "./SubsidiaryLedger.vue?vue&type=script&lang=js"
export * from "./SubsidiaryLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports